module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    staticStyle: {
      "min-width": "950px"
    },
    attrs: {
      "id": ""
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_chooseFile'),
      "size": ""
    },
    on: {
      "open": _vm.open,
      "close": _vm.fclose
    },
    model: {
      value: (_vm.isSelectFile),
      callback: function($$v) {
        _vm.isSelectFile = $$v
      },
      expression: "isSelectFile"
    }
  }, [_c('div', {
    staticClass: "gBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-row', {}, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "gSgLeftBtn",
    staticStyle: {
      "padding-left": "8px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_name'),
      "icon": "search",
      "on-icon-click": _vm.tquery
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.tquery($event)
      }
    },
    model: {
      value: (_vm.tqueryKey),
      callback: function($$v) {
        _vm.tqueryKey = $$v
      },
      expression: "tqueryKey"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "dpTable",
      "data": _vm.tableData,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange1
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "fileName",
      "align": "center",
      "label": _vm.$t('app_filename'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "fileVersion",
      "label": _vm.$t('app_version'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "formatter": _vm.setType,
      "label": _vm.$t('app_filetype'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.setSType,
      "align": "center",
      "label": _vm.$t('app_subtype'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (true),
            expression: "true"
          }],
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_choose'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.selected(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-check"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_chooseFile'),
      "size": ""
    },
    on: {
      "open": _vm.open,
      "close": _vm.fclose
    },
    model: {
      value: (_vm.isSelectFile1),
      callback: function($$v) {
        _vm.isSelectFile1 = $$v
      },
      expression: "isSelectFile1"
    }
  }, [_c('div', {
    staticClass: "gBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-row', {}, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "gSgLeftBtn",
    staticStyle: {
      "padding-left": "8px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_name'),
      "icon": "search",
      "on-icon-click": _vm.tquery1
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.tquery1($event)
      }
    },
    model: {
      value: (_vm.tqueryKey),
      callback: function($$v) {
        _vm.tqueryKey = $$v
      },
      expression: "tqueryKey"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "dpTable",
      "data": _vm.lcdata,
      "border": "",
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange1
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "launchername",
      "align": "center",
      "label": _vm.$t('app_filename'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "version",
      "label": _vm.$t('app_version'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "distrabutorname",
      "label": _vm.$t('app_distributor'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "center",
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (true),
            expression: "true"
          }],
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_choose'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.selected1(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-check"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.page,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.rules,
      "label-width": "12.5%",
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_taskName'),
      "prop": "tname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_input')
    },
    model: {
      value: (_vm.form.tname),
      callback: function($$v) {
        _vm.$set(_vm.form, "tname", $$v)
      },
      expression: "form.tname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_type'),
      "prop": "dtype"
    }
  }, [_c('el-radio-group', {
    on: {
      "input": _vm.change_device
    },
    model: {
      value: (_vm.form.dtype),
      callback: function($$v) {
        _vm.$set(_vm.form, "dtype", $$v)
      },
      expression: "form.dtype"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.device_type_1')))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_global.device_type_2')))])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "ptEditFr"
    }
  }, _vm._l((_vm.ulData), function(item, index) {
    return _c('div', {
      staticClass: "pteditdiv"
    }, [_c('div', {
      staticClass: "ptedlinecm"
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer",
        "position": "absolute",
        "width": "16px",
        "height": "16px",
        "left": "0"
      },
      attrs: {
        "src": _vm.delicon
      },
      on: {
        "click": function($event) {
          _vm.delrow(index)
        }
      }
    }), _vm._v(" "), _vm._v("\n\n\n\t\t\t\t\t\t" + _vm._s(_vm.$t('app_subtask')) + _vm._s(index + 1) + "\n\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "ptedlinecm"
    }, [_c('label', [_vm._v(_vm._s(_vm.$t('app_sltstype')))]), _vm._v("  \n\t\t\t\t\t\t"), _c('el-select', {
      attrs: {
        "placeholder": _vm.$t('app_type')
      },
      on: {
        "change": function($event) {
          _vm.taskChange(index, item)
        }
      },
      model: {
        value: (item.taskType),
        callback: function($$v) {
          _vm.$set(item, "taskType", $$v)
        },
        expression: "item.taskType"
      }
    }, _vm._l((_vm.tasktypes), function(item) {
      return _c('el-option', {
        key: item.type,
        attrs: {
          "label": item.name,
          "value": item.type
        }
      })
    }))], 1), _vm._v(" "), _c('div', {
      staticClass: "ptedlinecm"
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.taskType != '9' && item.content),
        expression: "item.taskType != '9' && item.content"
      }],
      staticClass: "el-icon-circle-check",
      staticStyle: {
        "line-height": "55px"
      }
    }), _vm._v(" "), _c('label', [_vm._v(_vm._s(item.taskType == '9' ? _vm.$t('app_command') : _vm.$t('app_chooseFile')))]), _vm._v("  \n\n\t\t\t\t\t\t"), _vm._v(" "), _c('el-select', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.taskType == '9'),
        expression: "item.taskType == '9'"
      }],
      staticStyle: {
        "width": "48%"
      },
      attrs: {
        "placeholder": _vm.$t('app_type')
      },
      on: {
        "change": function($event) {
          _vm.commChange(index, item)
        }
      },
      model: {
        value: (item.content),
        callback: function($$v) {
          _vm.$set(item, "content", $$v)
        },
        expression: "item.content"
      }
    }, _vm._l((_vm.comms), function(item) {
      return _c('el-option', {
        key: item.vl,
        attrs: {
          "label": item.lb,
          "value": item.vl
        }
      })
    })), _vm._v("  \n\n\t\t\t\t\t\t"), _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": item.file,
        "placement": "top"
      }
    }, [_c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.taskType != '9'),
        expression: "item.taskType != '9'"
      }],
      staticStyle: {
        "max-width": "55%",
        "text-overflow": "ellipsis",
        "overflow": "hidden"
      },
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.slFile(index, item.taskType)
        }
      }
    }, [_vm._v(_vm._s(item.file))])], 1), _vm._v(" "), _c('el-tooltip', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((item.content == 'XZYY' && !item.p2) || (item.content == 'ZQ' && !item.p1)),
        expression: "(item.content == 'XZYY' && !item.p2) || (item.content == 'ZQ' && !item.p1)"
      }],
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": item.file,
        "placement": "top"
      }
    }, [_c('el-button', {
      staticStyle: {
        "right": "0",
        "max-width": "43%",
        "text-overflow": "ellipsis",
        "overflow": "hidden",
        "position": "absolute",
        "line-height": "55px"
      },
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.slFile(index, item.taskType)
        }
      }
    }, [_vm._v(_vm._s(item.file))])], 1), _vm._v(" "), _c('el-input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((item.content == 'XZYY' && item.p2) || (item.content == 'ZQ' && item.p1)),
        expression: "(item.content=='XZYY'&&item.p2)||(item.content=='ZQ'&&item.p1)"
      }],
      staticStyle: {
        "width": "36%",
        "display": "inline-block"
      },
      attrs: {
        "placeholder": _vm.$t('app_ippkgname')
      },
      model: {
        value: (item.fileId),
        callback: function($$v) {
          _vm.$set(item, "fileId", $$v)
        },
        expression: "item.fileId"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ptedlinecm"
    }, [_c('i', {
      staticClass: "el-icon-caret-top",
      on: {
        "click": function($event) {
          _vm.sortEv(true, index, item)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "el-icon-caret-bottom",
      on: {
        "click": function($event) {
          _vm.sortEv(false, index, item)
        }
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isPop(item.taskType, item.content)),
        expression: "isPop(item.taskType, item.content)"
      }],
      staticClass: "ptedlinecm"
    }, [_c('el-popover', {
      attrs: {
        "placement": "bottom",
        "width": "200",
        "trigger": "click"
      },
      model: {
        value: (item.ispop),
        callback: function($$v) {
          _vm.$set(item, "ispop", $$v)
        },
        expression: "item.ispop"
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "reference",
        "type": "text"
      },
      slot: "reference"
    }, [_c('i', {
      staticClass: "el-icon-setting",
      staticStyle: {
        "margin-left": "5px"
      }
    })]), _vm._v(" "), _vm._l((_vm.getPopMenu(item.taskType, item.content)), function(title, pindex) {
      return _c('div', {
        style: (_vm.getPopCss(pindex, item.taskType, item.content))
      }, [_c('el-checkbox', {
        on: {
          "change": function($event) {
            _vm.paramChange(pindex + 1, index)
          }
        },
        model: {
          value: (item['p' + (pindex + 1)]),
          callback: function($$v) {
            _vm.$set(item, 'p' + (pindex + 1), $$v)
          },
          expression: "item['p'+(pindex+1)]"
        }
      }, [_vm._v(_vm._s(title))])], 1)
    })], 2)], 1)])
  })), _vm._v(" "), _c('div', {
    attrs: {
      "id": "ptAddTask"
    },
    on: {
      "click": _vm.addTask
    }
  }, [_vm._v("\n\t\t\t\t+" + _vm._s(_vm.$t('app_addsubts')) + "\n\t\t\t")]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save('form')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-111d4c95"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/ptask/edit.vue
// module id = 970
// module chunks = 0